import {createClientError} from '../dam/damClientError';

const uamfClientError = createClientError();

export default uamfClientError;
